export default __webpack_public_path__ + "static/media/mail.20307e4b.png";